<ifb-card>
  <mat-card appearance="raised">
    <mat-card-header class="card-header">
      <mat-card-title>Facility</mat-card-title>
      <button *ngIf="isEditAllowed"
              mat-icon-button
              routerLink="facility"
              aria-label="Edit">
        <mat-icon>edit</mat-icon>
      </button>
    </mat-card-header>
    <mat-card-content class="card-content">
      <mat-accordion>
        <mat-expansion-panel class="mat-elevation-z0">

          <mat-expansion-panel-header class="panel-header">
            <mat-panel-title>
              <div fxLayout="row">
                <div fxLayout="column">
                  <div>{{facility?.currentFacility?.name}}</div>
                  <div class="mat-caption">Facility name</div>
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div fxLayout="column"
               class="expanded-list"
               fxLayoutGap="32px">

            <div fxLayout="column"
                 *ngIf="!facility?.currentFacility?.isDefault">
              <div>{{facility?.currentFacility?.seniorLenders | join}}</div>
              <div class="mat-caption">Senior lenders</div>
            </div>

            <div fxLayout="column"
                 *ngIf="!facility?.currentFacility?.isDefault">
              <div>{{facility?.currentFacility?.mezzanineLenders | join}}</div>
              <div class="mat-caption">Mezzanine lenders</div>
            </div>

            <div *ngIf="facility?.history?.length > 0"
                 class="activity-title">Activity</div>
            <div *ngFor="let facilityHistory of reversedHistory"
                 fxLayout="column">
              <div>{{ facilityHistory | facitlityHistoryAssignementLabel }}</div>
              <div class="mat-caption">{{ facilityHistory.initiatedOnUtc | date: 'medium' }}</div>
            </div>
          </div>

        </mat-expansion-panel>

      </mat-accordion>
    </mat-card-content>
  </mat-card>
</ifb-card>
